import React, { useEffect, useRef, useState } from "react";
import { Modal } from "@mantine/core";
import { useUserProvider } from "@/utils/UserProvider";
import NewSectionsForm from "./NewSectionsForm";
import NewTemplateForm from "./NewTemplateForm";

interface TemplateData {
  templateName: string;
  templateDescription: string;
  isAdvancedTemplate: boolean;
  id?: string;
}

interface CreateTemplateProps {
  fetchTemplates?: () => Promise<void>;
  fetchTemplate?: () => Promise<void>;
  opened: boolean;
  onClose: () => void;
  selectedTemplate?: TemplateData;
}

const TemplateFormModal: React.FC<CreateTemplateProps> = ({
  opened,
  onClose,
  fetchTemplates,
  selectedTemplate,
  fetchTemplate,
}) => {
  const { mixpanel } = useUserProvider();
  const [step, setStep] = useState(1);
  const [templateData, setTemplateData] = useState<TemplateData>({
    templateName: "",
    templateDescription: "",
    isAdvancedTemplate: false,
  });
  const newTemplateFormRef = useRef<any>(null);
  const newSectionsFormRef = useRef<any>(null);

  const handleModalCancel = () => {
    setStep(1);
    newTemplateFormRef.current?.resetForm?.();
    newSectionsFormRef.current?.resetForm?.();
    onClose();
  };

  useEffect(() => {
    if (opened) {
      if (selectedTemplate) {
        setTemplateData(selectedTemplate);
        setStep(2);
      }
    }
  }, [opened, selectedTemplate]);

  const onNextStep = async (template: TemplateData) => {
    if (template?.isAdvancedTemplate) {
      handleModalCancel();
    } else {
      setStep(2);
      setTemplateData(template);
    }
  };

  return (
    <Modal
      opened={opened}
      onClose={handleModalCancel}
      title={step === 1 ? "Create a new template" : "Create sections"}
      size="lg"
      centered
    >
      {step === 1 ? (
        <NewTemplateForm
          fetchTemplates={fetchTemplates}
          onNextStep={onNextStep}
          ref={newTemplateFormRef}
          mixpanel={mixpanel}
        />
      ) : (
        <NewSectionsForm
          template={templateData}
          handleModalCancel={handleModalCancel}
          ref={newSectionsFormRef}
          fetchTemplate={fetchTemplate}
          isEditMode={!!selectedTemplate}
        />
      )}
    </Modal>
  );
};

export default TemplateFormModal;
